import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import NavigationUtil from 'utils/NavigationUtil';
import templateHtml from 'templates/notification/PendingWeightScaleRequestItemView.html';
import DateFormatter from 'utils/date/DateFormatter';
import DateParser from 'utils/date/DateParser';

// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';

var STATUS = {
    INVITED: 'INVITED',
    DECLINED: 'DECLINED',
    ACCEPTED: 'ACCEPTED'
};

var Events = {
    ON_NAVIGATION: 'ON_NAVIGATION'
};

var PendingWeightScaleRequestItemView = Backbone.View.extend({
    events: {
        'click .btn-get-started': 'onGetStartedButtonClicked',
        'click .btn-decline': 'onDeclineButtonClicked',
        'click .btn-undo-decline': 'onUndoDeclineButtonClicked',
        'click .js-select-user': 'onUserClicked'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.pendingDeviceInviteRequest = args.pendingDeviceInviteRequest;
        this.userProfile = args.userProfile;
        this.userPreferences = args.userPreferences;
        this.profileInfos = args.profileInfos;
    },

    render: function() {
        const pendingRequest = this.pendingDeviceInviteRequest.toJSON();
        const { invitorDisplayName, inviteDate, deviceInviteStatus, invitorName } = pendingRequest;
        const timeStamp = inviteDate && DateFormatter.formatRelativeTime(DateParser.parseISOUTC(inviteDate));

        const profileImageUrl = this.getProfileImageUrl();

        const i18nDeviceInvited = Localizer.localize('device.invited', pendingRequest.productDisplayName);

        let i18nDecline = Localizer.localize('button_delete');
        let i18nAccept = Localizer.localize('accept');
        let i18nDeclinedDesc = Localizer.localize('request.deleted');
        const i18nUndo = Localizer.localize('weight.scale.decline.undo.button');

        this.$el.html(
            this.template({
                i18nDecline,
                i18nAccept,
                i18nUndo,
                i18nDeclinedDesc,
                i18nDeviceInvited,
                pendingRequest,
                profileUrl: NavigationUtil.url(`/profile/${invitorDisplayName}`),
                getStartedUrl: NavigationUtil.url(this.getGetStartedUrl()),
                timeStamp,
                imageUrl: profileImageUrl,
                connectionName: invitorName
            })
        );

        if (deviceInviteStatus == STATUS.DECLINED) {
            this.displayDeclineMessages(true);
        }

        this.$('img.avatar').on('error', (evt) => {
            evt.target.src = profileImageHelperV2.getDefaultProfileImage();
            this.$('img.avatar').css('border-radius', '');
        });
    },

    onGetStartedButtonClicked: function(e) {
        e.preventDefault();
        this.pendingDeviceInviteRequest.set('deviceInviteStatus', STATUS.ACCEPTED);
        var url = this.getGetStartedUrl();
        this.trigger(Events.ON_NAVIGATION);
        Backbone.history.navigate(url, { trigger: true });
    },

    getGetStartedUrl: function() {
        return (
            '/device/get-started/' +
            this.pendingDeviceInviteRequest.get('deviceId') +
            '/invite/' +
            this.pendingDeviceInviteRequest.get('deviceInviteId')
        );
    },

    onDeclineButtonClicked: function(e) {
        e.preventDefault();

        var _this = this;
        this.pendingDeviceInviteRequest.set('deviceInviteStatus', STATUS.DECLINED);
        this.pendingDeviceInviteRequest.save(this.pendingDeviceInviteRequest.attributes, {
            success: function(model, response) {
                _this.displayDeclineMessages(true);
            }
        });
    },

    onUndoDeclineButtonClicked: function(e) {
        e.preventDefault();

        var _this = this;
        this.pendingDeviceInviteRequest.set('deviceInviteStatus', STATUS.INVITED);
        this.pendingDeviceInviteRequest.save(this.pendingDeviceInviteRequest.attributes, {
            success: function() {
                _this.displayDeclineMessages(false);
            }
        });
    },

    displayDeclineMessages: function(enable) {
        if (enable) {
            this.$('.inbox-response').show();
            this.$('.btn-get-started').hide();
            this.$('.btn-decline').hide();
        } else {
            this.$('.inbox-response').hide();
            this.$('.media-action').show();
            this.$('.btn-get-started').show();
            this.$('.btn-decline').show();
        }
    },

    onUserClicked: function(e) {
        var url = '/profile/' + this.pendingDeviceInviteRequest.get('invitorDisplayName');
        this.trigger(Events.ON_NAVIGATION);
        NavigationUtil.navigate(url, e);
    },

    getProfileImageUrl: function() {
        const userId = this.pendingDeviceInviteRequest.get('invitorId');
        const fallbackUrl = this.pendingDeviceInviteRequest.get('invitorProfilePicURL');
        /**
         * @type {SimplePublicSocialProfileV2DTO}
         */
        const dto = this.profileInfos?.[userId];
        return profileImageHelperV2.getDtoSmallIconImage(dto, fallbackUrl);
    }
});

PendingWeightScaleRequestItemView.STATUS = STATUS;
PendingWeightScaleRequestItemView.Events = Events;
export default PendingWeightScaleRequestItemView;
